import { shuffleArray } from "@/services/utils/common";
import {
  formatDate,
  upperSnakeCaseToNormalCase,
} from "@/services/utils/formatter";
import { get } from "lodash";

export const parseJobInformationModel = (item) => ({
  ...item,
  region: {
    ko: get(item, "district.name.ko") + ", " + get(item, "city.name.ko"),
    en: get(item, "district.name.en") + ", " + get(item, "city.name.en"),
  },
  tags: {
    ko: [get(item, "career.name.ko"), get(item, "duty.name.ko")],
    en: [get(item, "career.name.en"), get(item, "duty.name.en")],
  },
  positionInfo: {
    ko: `${get(item, "jobPositions[0].duty.name.ko")}, ${get(
      item,
      "jobPositions[0].career.name.ko"
    )}`,
    en: `${get(item, "jobPositions[0].duty.name.en")}, ${get(
      item,
      "jobPositions[0].career.name.en"
    )}`,
  },
});

export const parseJobRecruitmentModel = (item) => ({
  ...item,
  status:
    item.status === "none" ? "--" : upperSnakeCaseToNormalCase(item.status),
  receiptPeriod:
    formatDate(item.startPeriod) + " - " + formatDate(item.endPeriod),
});

export const parseCategoryJobModel = (categoryJob, count = 3) => {
  const newAdsJobs = categoryJob?.adsJobs?.map((categoryJobItem) => {
    const { job } = categoryJobItem;
    return {
      ...categoryJobItem,
      job: parseJobInformationModel(job),
    };
  });
  while (newAdsJobs?.length < count) {
    newAdsJobs.push({ job: { _id: "" } });
  }
  return { ...categoryJob, adsJobs: newAdsJobs };
};

export const parseCategoryJobModelShuffle = (categoryJob, count = 3) => {
  const newAdsJobs = categoryJob?.adsJobs?.map((categoryJobItem) => {
    const { job } = categoryJobItem;
    return {
      ...categoryJobItem,
      job: parseJobInformationModel(job),
    };
  });

  while (newAdsJobs?.length < count) {
    newAdsJobs.push({ job: { _id: "" } });
  }
  const shuffledAdsJobs = shuffleArray(newAdsJobs);
  return { ...categoryJob, adsJobs: shuffledAdsJobs };
};
